import { Component, Router } from 'llama'
import FaceDrawer from '../common/FaceDrawer'
import FacePortrait from './face/FacePortrait'
import OnboardingFooter from './face/OnboardingFooter'

import PopOverBox, { PopOverEvents } from '@winds-of-legends/wol-app-common/src/front/components/popover.js'
import * as popOverCss from 'bundle-text:@winds-of-legends/wol-app-common/src/front/assets/popover.css'
import popOverHtml from 'bundle-text:@winds-of-legends/wol-app-common/src/front/assets/popover.html'

import * as onboardingNameCss from 'bundle-text:./onboarding-name.css'
import OnboardingRoutes from './OnboardingRoutes'
import ApiClient from './api-client'

const passwdRX = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[.:;,?!@#$%^&*+_\\/'"{}()[\] -])[A-Za-z\d.:;,?!@#$%^&*+_\\/'"{}()[\] -]{8,}$/

export default class OnboardingRegister extends Component {
  constructor (opt) {
    super({
      ...opt,
      css: [
        popOverCss,
        onboardingNameCss,
        `
        input {
          font-size: xx-large;
        }

        input:focus:invalid {
          outline: 2px solid red;
        }

        input:focus:valid {
          outline: 2px solid black;
        }

        input:valid {
          border: 1px solid black;
        }

        input:invalid {
          border: 1px solid red;
        }

        input:invalid+span:after {
          position: absolute;
          content: '✖';
          padding-left: 5px;
        }

        input:valid+span:after {
          position: absolute;
          content: '✓';
          padding-left: 5px;
        }
        
        ul {
          list-style: none;
          margin-left: 0;
          padding-left: 0;
        }
        li {
          font-size: .5rem;
          padding-left: 1rem;
          text-indent: -1rem;
        }
        li::before {
          content: "✖";
          padding-right: 5px;
        }
        li.ok::before {
          content: "✓";
          padding-right: 5px;
        }
      `].join('\n'),
      html: () => {
        const onboardingName = document.getElementById('onboarding-name')
        const onboardingDescription = document.getElementById('onboarding-description')
        return popOverHtml +
        `<div id="onboarding">
        <div id="onboarding-header">
          <canvas id="onboarding-portrait" width="340" height="340"></canvas>
        </div>
        <div id="onboarding-body">
          <form id="onboarding-register-form" method="POST"  action="/onboarding/register" method="post">
            <h2>${onboardingName.value}</h2>
            <p>${onboardingDescription.value}</p>
            <label>${this.context.onboarding.email}</label>
            <input id="choose-email" name="email" required type="email">
            <label>${this.context.onboarding.password}</label>
            <input id="choose-password" name="password" required type="password">
            <p><input id="see-password" type="checkbox">${this.context.onboarding.see_password}</p>
            <ul>${
              Object.entries(this.context.onboarding.password_requirement)
              .map(([k, v]) => `<li id="login-password-${k}">${v}</li>`)
              .join('\n')
            }</ul>
          </form>
        </div>
        <div id="onboarding-footer"></div>
      </div>`
      }
    })

    this.faceDrawer = new FaceDrawer()
  }

  init (params, path) {
    const { eventBus, context } = this
    this.addChildren(
      params, path,

      new PopOverBox({
        eventBus, context, box: 'popover-box'//, logger: console
      }),

      new FacePortrait({
        eventBus,
        context,
        box: 'onboarding-portrait'
      }),
      new OnboardingFooter({
        eventBus,
        context,
        box: 'onboarding-footer',
        back: () => this.emit(Router.GO, OnboardingRoutes.Name()),
        submit: () => {
          const chooseEmail = this.gId('choose-email')
          const passwordInput = this.gId('choose-password')
          if (chooseEmail.value && passwordInput.value) {
            if (!chooseEmail.checkValidity()) {
              this.emit(PopOverEvents.MODAL_OPEN, this.context.onboarding.error.email_correct)
            } else if (!passwordInput.checkValidity()) {
              this.emit(PopOverEvents.MODAL_OPEN, this.context.onboarding.error.password_correct)
            } else {
              this.gId('onboarding-register-form').submit()
            }
          } else {
            this.emit(PopOverEvents.MODAL_OPEN,
              (
                !chooseEmail.value && !passwordInput.value
                  ? this.context.onboarding.error.both
                  : !chooseEmail.value
                      ? this.context.onboarding.error.email
                      : this.context.onboarding.error.password
              )
            )
          }
        }
      })
    )

    const chooseEmail = this.gId('choose-email')

    const onboardingEmail = document.getElementById('onboarding-email')
    chooseEmail.value = onboardingEmail.value

    let chooseEmailTO
    chooseEmail.addEventListener('input', () => {
      if (chooseEmailTO) clearTimeout(chooseEmailTO)
      chooseEmailTO = setTimeout(() => {
        this.emit(ApiClient.UPDATE_DATA, { email: chooseEmail.value.trim() }, () => {
          chooseEmail.value = chooseEmail.value.trim()
          onboardingEmail.value = chooseEmail.value.trim()
        })
      }, 500)
    })

    const passwdMin8Cond = (x) => x.length >= 8
    const passwdLetterCond = (x) => /[A-Za-z]/.test(x)
    const passwdDigitCond = (x) => /\d/.test(x)
    const passwdSpecialCond = (x) => /[.:;,?!@#$%^&*+_\\/'"{}()[\] -]/.test(x)

    const passwordInput = this.gId('choose-password')
    passwordInput.addEventListener('input', () => {
      const value = passwordInput.value

      if (passwdMin8Cond(value)) this.gId('login-password-min8').classList.add('ok')
      else this.gId('login-password-min8').classList.remove('ok')

      if (passwdLetterCond(value)) this.gId('login-password-letter').classList.add('ok')
      else this.gId('login-password-letter').classList.remove('ok')

      if (passwdDigitCond(value)) this.gId('login-password-digit').classList.add('ok')
      else this.gId('login-password-digit').classList.remove('ok')

      if (passwdSpecialCond(value)) this.gId('login-password-special').classList.add('ok')
      else this.gId('login-password-special').classList.remove('ok')

      if (!passwdRX.test(value)) {
        passwordInput.setCustomValidity(this.context.register.invalid_passwd)
      } else {
        passwordInput.setCustomValidity('')
      }
      // passwordInput.reportValidity()

      const seePassword = this.gId('see-password')
      seePassword.addEventListener('click', () => {
        if (seePassword.checked) {
          passwordInput.type = 'text'
        } else {
          passwordInput.type = 'password'
        }
      })
    })
  }
}
